/**
 * Canonical `dialect_key` strings used by the prompt resolver and school config.
 * The student UI still loads the **list** of choices from `/v1/tutor/dialect-options` (see PictureTalkScenePage);
 * those options use these same keys as `value`. Keep literals here so defaults and checks stay aligned with the API.
 */
export const PICTURE_TALK_STANDARD_DIALECT_KEY = 'standard_tamil';
export const PICTURE_TALK_EELAM_DIALECT_KEY = 'eelam_tamil';
